import { lazy } from 'react';

export const ExempleHomePage = lazy(() => import('./features/exemple/pages/ExempleHomePage'));

export const ExempleVersionDataPage = lazy(
    () => import('./features/exemple/pages/ExempleVersionDataPage'),
);

export const MapPage = lazy(() => import('./features/map/pages/MapPage'));
